import { PRIVACY_BADGES } from '../../constants';

type PrivacyIconType = (typeof PRIVACY_BADGES)[number]['icon'];

const iconPaths: Record<PrivacyIconType, string> = {
  caduceus: '/images/icons/payment-page-v2/icon-caduceus.svg',
  lock: '/images/icons/payment-page-v2/icon-ssl-lock.svg',
  'no-sale': '/images/icons/payment-page-v2/icon-no-sale.svg',
};

const PrivacyBadge = ({ icon, label }: { icon: PrivacyIconType; label: string }) => (
  <div className="flex items-center gap-2 px-3 py-2 bg-white border border-slate-200 rounded-full">
    <img
      src={iconPaths[icon]}
      alt=""
      className="w-4 h-4 [filter:invert(67%)_sepia(37%)_saturate(1752%)_hue-rotate(331deg)_brightness(101%)_contrast(101%)]"
    />
    <span className="text-sm text-catch-dark-blue-90">{label}</span>
  </div>
);

export const PrivacySection = () => {
  return (
    <div className="w-full bg-white rounded-xl border-1 border-solid border-[#E3DCCE] p-6">
      <h3 className="text-xl font-bold text-catch-dark-blue-90 mb-2">Your data stays yours</h3>
      <p className="text-sm text-slate-500 mb-4">
        We take privacy seriously— not just &quot;we have a policy&quot; seriously.
      </p>

      {/* Privacy badges */}
      <div className="flex flex-wrap gap-2">
        {PRIVACY_BADGES.map((badge) => (
          <PrivacyBadge key={badge.id} icon={badge.icon} label={badge.label} />
        ))}
      </div>
    </div>
  );
};

export default PrivacySection;
